export type RemoveAccountFailure = 'failed' | 'owner_of_open_venue'

export const OWNER_OF_OPEN_VENUE = 'owner_of_open_venue'

type ErrorBody = {reason?: unknown; code?: unknown; error?: unknown; message?: unknown; name?: unknown}

/**
 * DELETE /users/ answers 409 with the code `owner_of_open_venue` when the person is the only owner of a venue that
 * is still open. The server keeps the code in the body; read the usual places so a change of key does not hide it.
 */
export const getRemoveAccountFailure = (error: unknown): RemoveAccountFailure => {
  const response = (error as {response?: {status?: number; data?: ErrorBody | string}} | null)?.response
  if (response?.status !== 409) {
    return 'failed'
  }
  const data = response.data
  const text = typeof data === 'string' ? [data] : [data?.reason, data?.code, data?.error, data?.message, data?.name]
  return text.some((value) => typeof value === 'string' && value.includes(OWNER_OF_OPEN_VENUE))
    ? OWNER_OF_OPEN_VENUE
    : 'failed'
}
